import { render, staticRenderFns } from "./PostalCodeComponent.vue?vue&type=template&id=513aca06&scoped=true&"
import script from "./PostalCodeComponent.vue?vue&type=script&lang=js&"
export * from "./PostalCodeComponent.vue?vue&type=script&lang=js&"
import style0 from "./PostalCodeComponent.vue?vue&type=style&index=0&id=513aca06&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513aca06",
  null
  
)

export default component.exports